import script from "./WeatherWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./WeatherWidget.vue?vue&type=script&setup=true&lang=js"

import "./WeatherWidget.vue?vue&type=style&index=0&id=dee79bf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dee79bf2"]])

export default __exports__